<template>
  <div class="index" v-cloak>
    <div class="header acea-row row-center-wrapper">
      <div class="current-city-container" @click="cityShow">
        <div class="current-city-name">{{ cityName }}</div>
        <div class="select-city-indicator"></div>
      </div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="search acea-row row-middle"
          >
            <img v-lazy="item.pic" v-if="index != 0" />
            <img :src="item.pic" v-else />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img v-lazy="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>

    <div class="period-activities">
      <router-link
        class="activitiy"
        v-for="(activity, aindex) in activity"
        :key="aindex"
        :to="
          activity.wap_link
            ? activity.wap_link
            : {
                name: 'ActivityDetails',
                query: { id: activity.id, city_id: cityId }
              }
        "
      >
        <img v-lazy="activity.pic" width="100%" />
      </router-link>
    </div>
    <div class="news acea-row row-between-wrapper">
      <div class="pictrue"><img src="@assets/images/news.png" /></div>
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="content-box content-tab">
      <div class="box-slider-head"></div>
      <yd-tab>
        <yd-tab-panel label="热门线路">
          <div class="tab-box">
            <swiper :options="swiperPagerOption">
              <swiper-slide
                class="box-slider"
                v-for="(activityList, index) in hotList"
                :key="index"
              >
                <template v-for="(activity, aindex) in activityList">
                  <router-link
                    :key="aindex"
                    :to="
                      activity.wap_url
                        ? activity.wap_url
                        : {
                            name: 'ActivityDetails',
                            query: { id: activity.id, city_id: cityId }
                          }
                    "
                    class="box-slider-item"
                  >
                    <div
                      class="day-count"
                      data-type="1"
                      :style="
                        'background-image: url(' +
                          activity.image +
                          '?x-oss-process=image/resize,w_520);'
                      "
                    >
                      <div class="day-count-content" v-if="activity.day > 0">
                        {{ activity.day }}天
                      </div>
                      <div class="activity-price">{{ activity.price }}元</div>
                    </div>
                    <div class="title">{{ activity.store_name }}</div>
                    <!-- <div class="info">
                      <div class="viewing">4632人在看</div>
                      <div class="content"><span>冰雪净土 一年仅2月</span></div>
                    </div> -->
                  </router-link>
                </template>
              </swiper-slide>
              <div
                class="swiper-pagination paginationBanner"
                slot="pagination"
              ></div>
            </swiper>
          </div>
        </yd-tab-panel>
        <yd-tab-panel label="口碑推荐">
          <div class="tab-box">
            <swiper :options="swiperPagerOption">
              <swiper-slide
                class="box-slider"
                v-for="(activityList, index) in bestList"
                :key="index"
              >
                <template v-for="(activity, aindex) in activityList">
                  <router-link
                    :key="aindex"
                    :to="
                      activity.wap_url
                        ? activity.wap_url
                        : {
                            name: 'ActivityDetails',
                            query: { id: activity.id, city_id: cityId }
                          }
                    "
                    class="box-slider-item"
                  >
                    <div
                      class="day-count"
                      data-type="1"
                      :style="
                        'background-image: url(' +
                          activity.image +
                          '?x-oss-process=image/resize,w_520);'
                      "
                    >
                      <div class="day-count-content" v-if="activity.day > 0">
                        {{ activity.day }}天
                      </div>
                      <div class="activity-price">{{ activity.price }}元</div>
                    </div>
                    <div class="title">{{ activity.store_name }}</div>
                    <!-- <div class="info">
                      <div class="viewing">4632人在看</div>
                      <div class="content"><span>冰雪净土 一年仅2月</span></div>
                    </div> -->
                  </router-link>
                </template>
              </swiper-slide>
              <div
                class="swiper-pagination paginationBanner"
                slot="pagination"
              ></div>
            </swiper>
          </div>
        </yd-tab-panel>
        <yd-tab-panel label="最新上线">
          <div class="tab-box">
            <swiper :options="swiperPagerOption">
              <swiper-slide
                class="box-slider"
                v-for="(activityList, index) in firstList"
                :key="index"
              >
                <template v-for="(activity, aindex) in activityList">
                  <router-link
                    :key="aindex"
                    :to="
                      activity.wap_url
                        ? activity.wap_url
                        : {
                            name: 'ActivityDetails',
                            query: { id: activity.id, city_id: cityId }
                          }
                    "
                    class="box-slider-item"
                  >
                    <div
                      class="day-count"
                      data-type="1"
                      :style="
                        'background-image: url(' +
                          activity.image +
                          '?x-oss-process=image/resize,w_520);'
                      "
                    >
                      <div class="day-count-content" v-if="activity.day > 0">
                        {{ activity.day }}天
                      </div>
                      <div class="activity-price">{{ activity.price }}元</div>
                    </div>
                    <div class="title">{{ activity.store_name }}</div>
                    <!-- <div class="info">
                      <div class="viewing">4632人在看</div>
                      <div class="content"><span>冰雪净土 一年仅2月</span></div>
                    </div> -->
                  </router-link>
                </template>
              </swiper-slide>
              <div
                class="swiper-pagination paginationBanner"
                slot="pagination"
              ></div>
            </swiper>
          </div>
        </yd-tab-panel>
      </yd-tab>
    </div>
    <!-- <div class="content-box three-grid-view">
      <div class="three-grid-view-container">
        <a
          href="http://opr.32hike.com/h5/hotel/detail/list?ft=web_i5_3327"
          class="grid-view-item grid-view-big"
          data-img="http://img0.imgtn.bdimg.com/it/u=2177824281,4083690787&fm=26&gp=0.jpg"
          data-type="1"
          style='background-image: url("http://img0.imgtn.bdimg.com/it/u=2177824281,4083690787&fm=26&gp=0.jpg");'
        >
          <div class="grid-view-stage"></div>
          <div class="grid-view-text">
            <div class="grid-view-name">臻选美宿</div>
            <div class="grid-view-title">度假自由行，首单立减¥50</div>
          </div>
        </a>
        <a
          href="http://opr.32hike.cn/freeget/list.html?ft=web_i5_3327&amp;mp_type=9"
          class="grid-view-item grid-view-normal"
          data-img="http://img5.imgtn.bdimg.com/it/u=3043696922,1813961857&fm=26&gp=0.jpg"
          data-type="1"
          style='background-image: url("http://img5.imgtn.bdimg.com/it/u=3043696922,1813961857&fm=26&gp=0.jpg");'
        >
          <div class="grid-view-stage"></div>
          <div class="grid-view-text">
            <div class="grid-view-name">臻选免费领</div>
            <div class="grid-view-title">邀好友助力，0元获好物</div>
          </div>
        </a>
        <a
          href="https://opr.32hike.com/weue/week/list?type=3&amp;id=121&amp;ft=web_i5_3327"
          class="grid-view-item grid-view-normal"
          data-img="http://img1.imgtn.bdimg.com/it/u=3551088816,3397202525&fm=15&gp=0.jpg"
          data-type="1"
          style='background-image: url("http://img1.imgtn.bdimg.com/it/u=3551088816,3397202525&fm=15&gp=0.jpg");'
        >
          <div class="grid-view-stage"></div>
          <div class="grid-view-text">
            <div class="grid-view-name">冬日赏雪</div>
            <div class="grid-view-title">雪国童话，冰河世纪</div>
          </div>
        </a>
      </div>
    </div> -->
    <div class="content-box">
      <div class="flat-list-title">产品精选</div>
      <div class="flat-list-second-title" style="padding-bottom:0.47rem;">
        — 精心定制 不可错过 —
      </div>
      <div class="flat-list-container">
        <div class="flat-list">
          <router-link
            v-for="(activity, index) in goodList"
            :key="index"
            class="flat-list-item"
            :to="
              activity.wap_url
                ? activity.wap_url
                : {
                    name: 'ActivityDetails',
                    query: { id: activity.id, city_id: cityId }
                  }
            "
          >
            <div
              class="flat-list-item-img"
              :style="
                'background-image: url(' +
                  activity.image +
                  '?x-oss-process=image/resize,w_520);'
              "
            >
              <div class="flat-list-item-time" v-if="activity.day > 0">
                {{ activity.day }}天
              </div>
              <div class="activity-price">{{ activity.price }}元</div>
            </div>
            <div class="flat-list-item-info">
              <div class="flat-list-item-digest">
                <div class="flat-list-item-name">
                  {{ activity.store_name }}
                </div>
                <!-- <div class="flat-list-item-desc">
                  <div class="flat-list-item-count">38人去过</div>
                  <div class="flat-list-item-score">4.38分</div>
                </div> -->
              </div>
              <!-- <div class="flat-list-item-btn">查看</div> -->
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- <div class="content-box">
      <div class="hori-swiper-list-head">
        <img
          class="hori-swiper-list-img"
          src="../../assets/images/new_img.png"
          width="8%"
          style="margin-right:1vw;"
        />
        <div class="hori-swiper-list-title">臻选美宿</div>
      </div>
      <div class="hori-swiper-list-sec-title">— 臻选优质民宿酒店 —</div>
      <div class="hori-swiper-list">
        <swiper :options="swiperPagerOption">
          <swiper-slide
            class="box-slider"
            v-for="(activity, index) in jingxuanActivities"
            :key="index"
          >
            <router-link
              :to="activity.wap_url ? activity.wap_url : ''"
              class="hori-swiper-list-item"
            >
              <div class="hori-swiper-list-item-head">
                <div
                  class="hori-swiper-list-item-img"
                  :style="'background-image: url(' + activity.coverUrl + ');'"
                ></div>
                <div class="hori-swiper-list-item-price">￥858起</div>
              </div>
              <div class="hori-swiper-list-item-body">
                <div class="hori-swiper-list-item-name">
                  广州从化圣托利温泉庄园
                </div>
                <div class="hori-swiper-list-item-detail">
                  <span class="hori-swiper-list-item-higlight-text"
                    >高级双床房
                    约20-25m²|含双人早餐|2张1.3m单人床|无限次公共温泉</span
                  >
                  <span class="hori-swiper-list-item-text"
                    >浓郁的南欧地中海风情，享受网红酒店的文艺与别致，温泉与泳池的双重感受，喜欢拍照打卡的你绝对不能错过！</span
                  >
                </div>
              </div>
            </router-link>
          </swiper-slide>
          <div
            class="swiper-pagination paginationBanner"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </div> -->
    <!-- <div class="content-box">
      <div class="six-grid-view" data-id="1240">
        <div class="block-title six-grid-view-title">童步营</div>
        <div class="block-second-title six-grid-view-second-title">
          — 陪伴他们闯荡世界 —
        </div>
        <div class="six-grid-views">
          <swiper :options="swiperPagerOption">
            <swiper-slide
              class="box-slider item-content"
              v-for="(activity, index) in tongbuyingActivities"
              :key="index"
            >
              <a
                class="item-content-link"
                href="https://wx.32hike.com/wechat/v4/activity/index?aid=56771&amp;ft=web_i5_1240"
              >
                <div
                  class="item-bg"
                  data-img="http://img1.imgtn.bdimg.com/it/u=1734073965,524448280&fm=26&gp=0.jpg"
                  data-type="1"
                  :style="'background-image: url(' + activity.coverUrl + ');'"
                >
                  <div class="item-head">1天</div>
                </div>
                <div class="item-title">植物探秘公开课</div>
                <div class="item-digest">
                  <div class="item-text">4.93分</div>
                </div>
              </a>
            </swiper-slide>
            <div
              class="swiper-pagination paginationBanner"
              slot="pagination"
            ></div>
          </swiper>
        </div>
      </div>
    </div> -->
    <!-- 
    <div class="content-box" style="background-color: transparent;">
      <div class="hori-swiper-preview-container" data-id="1231">
        <div class="block-title preview-title">
          爆款线路
        </div>
        <div class="block-second-title preview-second-title">
          — 款款精品 好评如潮 —
        </div>
        <div class="preview-content-wraper">
          <div
            class="preview-item"
            v-for="(item, aindex) in activities"
            :key="item.coverUrl"
          >
            <a
              href="https://wx.32hike.com/wechat/v4/activity/index?aid=54330&amp;ft=web_i5_1231"
              class="preview-item-link"
              :data-img="item.coverUrl"
              data-type="1"
              :style="'background-image: url(' + item.coverUrl + ');'"
            >
              <div class="preview-item-thumb"></div>
              <div class="preview-item-head">
                <div class="preview-item-head-content">
                  <div class="preview-item-head-text">
                    TOP
                  </div>
                  <div class="preview-item-head-count">
                    {{ aindex > 10 ? aindex++ : "0" + (aindex + 1) }}
                  </div>
                </div>
              </div>
              <div>
                <div class="preview-item-base">
                  <div class="preview-item-title">
                    【北欧童话】阿尔山+冷极村冰雪童话
                  </div>
                  <div class="preview-item-statistics">
                    <div class="preview-item-been-num">
                      564人去过
                    </div>
                    <div class="preview-item-grade">
                      4.83分
                    </div>
                  </div>
                  <div class="preview-item-view-trigger">
                    <span class="preview-item-trigger-text">查看</span>
                  </div>
                </div>
              </div>
            </a>
            <swiper
              :options="swiperSpaceBetweenOption"
              class="arrangement-list"
            >
              <swiper-slide class="arrangement-item arrangement-triggered">
                <a
                  href="https://wx.32hike.com/wechat/v4/activity/index?aid=54330&amp;ft=web_i5_1231"
                  class="arrangement-item-link"
                >
                  <div class="arrangement-item-base">
                    <div class="arrangement-day">
                      <span class="arrangement-day-text">01月12</span>~01月18
                    </div>
                    <div class="arrangement-result orange">
                      即将成行
                    </div>
                  </div>
                </a>
              </swiper-slide>
              <swiper-slide class="arrangement-item arrangement-triggered">
                <a
                  href="https://wx.32hike.com/wechat/v4/activity/index?aid=54330&amp;ft=web_i5_1231"
                  class="arrangement-item-link"
                >
                  <div class="arrangement-item-base">
                    <div class="arrangement-day">
                      <span class="arrangement-day-text">01月12</span>~01月18
                    </div>
                    <div class="arrangement-result highing">
                      报名中
                    </div>
                  </div>
                </a>
              </swiper-slide>
              <swiper-slide class="arrangement-item arrangement-triggered">
                <a
                  href="https://wx.32hike.com/wechat/v4/activity/index?aid=54330&amp;ft=web_i5_1231"
                  class="arrangement-item-link"
                >
                  <div class="arrangement-item-base">
                    <div class="arrangement-day">
                      <span class="arrangement-day-text">01月12</span>~01月18
                    </div>
                    <div class="arrangement-result full">
                      已满员
                    </div>
                  </div>
                </a>
              </swiper-slide>
              <swiper-slide class="arrangement-item arrangement-triggered">
                <a
                  href="https://wx.32hike.com/wechat/v4/activity/index?aid=54330&amp;ft=web_i5_1231"
                  class="arrangement-item-link"
                >
                  <div class="arrangement-item-base">
                    <div class="arrangement-day">
                      <span class="arrangement-day-text">01月12</span>~01月18
                    </div>
                    <div class="arrangement-result full">
                      已满员
                    </div>
                  </div>
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div
      class="content-box tab-second-grid-view"
      style="background-color: transparent;">
      <div class="second-grid-view-head">
        <div class="second-grid-view-more">
          更多活动
        </div>
      </div>
      <yd-tab>
        <yd-tab-panel label="全部">
          <div class="tab-box">
            <div class="grid-view-content active">
              <div class="grid-view-body">
                <a
                  href="https://wx.32hike.com/wechat/v4/activity/index?aid=54578&amp;ft=web_i5_more_1"
                  class="grid-view-item"
                  v-for="(moreActivity, index) in moreActivities"
                  :key="index"
                >
                  <div
                    class="grid-view-item-digest"
                    :data-img="moreActivity.coverUrl"
                    data-type="1"
                    :style="
                      'background-image: url(' + moreActivity.coverUrl + ');'
                    "
                  >
                    <div class="grid-view-item-duration">
                      7天
                    </div>
                  </div>
                  <div class="grid-view-item-base">
                    <div class="grid-view-item-title ">
                      【冰雪九寨】川北童话世界A团
                    </div>
                    <div class="grid-view-item-price">
                      ￥3680
                    </div>
                  </div>
                </a>
              </div>
              <div class="grid-view-loading-wrapper" style="display:none;">
                <div class="grid-view-loading"></div>
              </div>
            </div>
          </div>
        </yd-tab-panel>
        <yd-tab-panel label="周边">
          <div class="tab-box"></div>
        </yd-tab-panel>
        <yd-tab-panel label="境内">
          <div class="tab-box"></div>
        </yd-tab-panel>
      </yd-tab>
    </div> -->
    <div style="height:1.2rem;"></div>
    <yd-popup v-model="showCityPopup" position="center" width="90%">
      <div class="city-container" style="background-color:#fff;">
        <div class="city-close" @click="cityClose"></div>
        <h5 class="chose-city-title">请选择你的城市</h5>
        <div class="city-list">
          <div
            class="city-item"
            v-for="(city, cityIndex) in cities"
            :key="cityIndex"
            @click="selectCity(city)"
          >
            <div
              class="city-thumb"
              :style="'background-image: url(' + city.icon + ');'"
            >
              <div class="city-checked" v-if="city.id === cityId"></div>
            </div>
            <div class="city-name">{{ city.name }}</div>
          </div>
        </div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getHomeData, getShare, getCityList } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { Popup } from "vue-ydui/dist/lib.rem/popup";
import { Tab, TabPanel } from "vue-ydui/dist/lib.rem/tab";

const HAS_COUPON_WINDOW = "has_coupon_window";
const CURRENT_CITY_ID = "current_city_id";
const CURRENT_CITY_NAME = "current_city_name";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    [Popup.name]: Popup,
    [Tab.name]: Tab,
    [TabPanel.name]: TabPanel
  },
  props: {},
  data: function() {
    return {
      showCityPopup: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      cities: [],
      cityId: null,
      cityName: "",
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      goodList: [],
      // jingxuanActivities: [
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   },
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   }
      // ],
      // mingsuActivities: [
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   }
      // ],
      // tongbuyingActivities: [
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   }
      // ],
      // baokuanActivities: [
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   }
      // ],
      // activities: [
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   }
      // ],
      // moreActivities: [
      //   {
      //     coverUrl:
      //       "http://img4.imgtn.bdimg.com/it/u=1703094090,802953328&fm=26&gp=0.jpg"
      //   }
      // ],
      bestBanner: [],
      hotList: [],
      bestList: [],
      firstList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperPagerOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">${index +
              1}</span>`;
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperSpaceBetweenOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  mounted: function() {
    let that = this;
    that.$dialog.loading.open("首页数据加载中...");
    getCityList()
      .then(res => {
        that.$set(that, "cities", Object.values(res.data));
        if (
          (!cookie.has(CURRENT_CITY_ID) || !cookie.get(CURRENT_CITY_ID)) &&
          that.cities.length > 0
        ) {
          cookie.set(CURRENT_CITY_ID, that.cities[0]["id"]);
          cookie.set(CURRENT_CITY_NAME, that.cities[0]["name"]);
        }
        this.cityId = cookie.get(CURRENT_CITY_ID);
        this.cityName = cookie.get(CURRENT_CITY_NAME);
      })
      .catch(e => {
        console.log(e);
        that.$dialog.loading.close();
      });
  },
  watch: {
    cityId(value) {
      this.getHomeData({ city_id: value });
    }
  },
  methods: {
    getHomeData(data) {
      let that = this;
      getHomeData(data)
        .then(res => {
          that.logoUrl = res.data.logoUrl;
          that.$set(that, "banner", res.data.banner);
          that.$set(that, "menus", res.data.menus);
          that.$set(that, "roll", res.data.roll);
          that.$set(that, "bestBanner", res.data.info.bestBanner);
          that.$set(
            that,
            "hotList",
            this.groupListByNum(res.data.info.hotList, 4)
          );
          that.$set(
            that,
            "bestList",
            this.groupListByNum(res.data.info.bestList, 4)
          );
          that.$set(
            that,
            "firstList",
            this.groupListByNum(res.data.info.firstList, 4)
          );
          that.$set(that, "activity", res.data.activity);
          that.$set(that, "goodList", res.data.good_list);
          // if (res.data.activity.length) {
          //   var activityOne = res.data.activity.shift();
          //   that.$set(that, "activityOne", activityOne);
          // }
          // that.$set(that, "info", res.data.info);
          // that.$set(that, "likeInfo", res.data.likeInfo);
          // that.$set(
          //   that,
          //   "lovely",
          //   res.data.lovely.length ? res.data.lovely[0] : {}
          // );
          // that.$set(that, "benefit", res.data.benefit);
          // that.$set(that, "couponList", res.data.couponList);
          that.setOpenShare();
          // this.showCoupon =
          //   !cookie.has(HAS_COUPON_WINDOW) &&
          //   res.data.couponList.some(coupon => coupon.is_use);
          that.$dialog.loading.close();
        })
        .catch(e => {
          console.log(e);
          that.$dialog.loading.close();
        });
    },
    selectCity(city) {
      cookie.set(CURRENT_CITY_ID, city.id);
      cookie.set(CURRENT_CITY_NAME, city.name);
      this.cityId = cookie.get(CURRENT_CITY_ID);
      this.cityName = cookie.get(CURRENT_CITY_NAME);
      this.showCityPopup = false;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    cityClose() {
      this.showCityPopup = false;
    },
    cityShow() {
      this.showCityPopup = true;
    },
    groupListByNum(list, num) {
      let listGroup = [];
      let temp = [];
      list.forEach((item, index) => {
        if ((index + 1) % num === 0) {
          temp.push(item);
          listGroup.push(temp);
          temp = [];
        } else {
          temp.push(item);
          if (index + 1 === list.length) {
            listGroup.push(temp);
          }
        }
      });
      console.log(listGroup, list);
      return listGroup;
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style scoped>
.index {
  background-color: #fff;
}
</style>
